// extracted by mini-css-extract-plugin
export default {"wrapper":"xo-z","response":"yo-z","error":"zo-z","disabled":"Ao-z","buttons":"Bo-z","feedbackQuestionSection":"Co-z","yesNoWrapper":"Do-z"};